import { useMemo } from "react";

const ema = (arr, period) => {
  const k = 2 / (period + 1);
  const out = []; let prev;
  arr.forEach((v, i) => { prev = i === 0 ? v : v * k + prev * (1 - k); out.push(prev); });
  return out;
};
const sma = (arr, period) => arr.map((_, i) => (i < period - 1 ? null : arr.slice(i - period + 1, i + 1).reduce((a, b) => a + b, 0) / period));
const stdev = (arr, period) => arr.map((_, i) => {
  if (i < period - 1) return null;
  const slice = arr.slice(i - period + 1, i + 1);
  const m = slice.reduce((a, b) => a + b, 0) / period;
  return Math.sqrt(slice.reduce((a, b) => a + (b - m) ** 2, 0) / period);
});
const rsi14 = (arr) => {
  const out = [null]; let gain = 0, loss = 0;
  for (let i = 1; i < arr.length; i++) {
    const d = arr[i] - arr[i - 1];
    const g = d > 0 ? d : 0, l = d < 0 ? -d : 0;
    if (i <= 14) { gain += g; loss += l; out.push(null); if (i === 14) { gain /= 14; loss /= 14; out[out.length - 1] = 100 - 100 / (1 + gain / (loss || 1e-9)); } }
    else { gain = (gain * 13 + g) / 14; loss = (loss * 13 + l) / 14; out.push(100 - 100 / (1 + gain / (loss || 1e-9))); }
  }
  return out;
};

// Turns a CoinGecko market_chart payload into chart rows with MA/BB/RSI/MACD columns.
export const useChartSeries = (chart, range) => useMemo(() => {
  const prices = chart?.prices || [];
  const vols = chart?.total_volumes || [];
  const arr = prices.map(([, p]) => p);
  let tech = { rsi: [], macd: [], signalLine: [], ma20: [], ma50: [], bbUp: [], bbLo: [] };
  if (arr.length >= 30) {
    const e12 = ema(arr, 12), e26 = ema(arr, 26);
    const macd = e12.map((v, i) => v - e26[i]);
    const ma20 = sma(arr, 20), sd20 = stdev(arr, 20);
    tech = {
      rsi: rsi14(arr), macd, signalLine: ema(macd, 9), ma20, ma50: sma(arr, 50),
      bbUp: ma20.map((m, i) => (m && sd20[i] ? m + 2 * sd20[i] : null)),
      bbLo: ma20.map((m, i) => (m && sd20[i] ? m - 2 * sd20[i] : null)),
    };
  }
  return prices.map(([ts, p], i) => ({
    ts, p,
    time: new Date(ts).toLocaleDateString(undefined, { month: "short", day: "numeric", hour: range === "1" ? "2-digit" : undefined }),
    rsi: tech.rsi[i], macd: tech.macd[i], macdSignal: tech.signalLine[i],
    ma20: tech.ma20[i], ma50: tech.ma50[i], bbUp: tech.bbUp[i], bbLo: tech.bbLo[i],
    v: vols[i]?.[1],
  }));
}, [chart, range]);
